import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PageTransition, StaggerContainer, StaggerItem } from '../components/PageTransition';

// The Bear House Logo
const Logo = () => (
  <div className="flex justify-center w-full mb-8">
    <img 
      src="/tbh-logo.png" 
      alt="The Bear House" 
      className="w-48 md:w-56 h-auto"
      data-testid="tbh-logo-nav"
    />
  </div>
);

const NavButton = ({ label, onClick, testId }) => (
  <motion.button
    onClick={onClick}
    className="w-full py-6 px-12 bg-white border border-[rgba(26,26,26,0.1)] text-[#1A1A1A] text-xl md:text-2xl font-light tracking-[0.2em] uppercase transition-all duration-500 hover:border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-[#F8F6F2]"
    whileHover={{ y: -4 }}
    whileTap={{ scale: 0.98 }}
    data-testid={testId}
  >
    {label}
  </motion.button>
);

const MainNavigation = () => {
  const navigate = useNavigate();

  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] flex flex-col items-center justify-center px-6 py-12">
      <div className="grain-overlay" />
      
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mb-8"
      >
        <Logo />
        <h1 className="text-2xl md:text-3xl font-light tracking-[0.1em] text-[#1A1A1A] text-center">
          Training & Development Portal
        </h1>
      </motion.div>

      <StaggerContainer className="flex flex-col gap-6 w-full max-w-md">
        <StaggerItem>
          <NavButton 
            label="What" 
            onClick={() => navigate('/what')} 
            testId="nav-what-btn"
          />
        </StaggerItem>
        <StaggerItem>
          <NavButton 
            label="Why" 
            onClick={() => navigate('/why')} 
            testId="nav-why-btn"
          />
        </StaggerItem>
        <StaggerItem>
          <NavButton 
            label="Who" 
            onClick={() => navigate('/who')} 
            testId="nav-who-btn"
          />
        </StaggerItem>
      </StaggerContainer>

      <motion.button
        onClick={() => navigate('/')}
        className="mt-16 text-xs uppercase tracking-[0.15em] text-[#1A1A1A]/50 hover:text-[#1A1A1A] transition-colors duration-300"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
        data-testid="back-to-landing"
      >
        ← Back to Landing
      </motion.button>
    </PageTransition>
  );
};

export default MainNavigation;
